// ===== ROTINAS & ATIVIDADES =====
const ROT_STATUS={pendente:'A fazer',em_andamento:'Em andamento',aguardando:'Aguardando',concluido:'Concluído'};
const ROT_STATUS_COL={pendente:'var(--muted)',em_andamento:'var(--accent)',aguardando:'var(--warn)',concluido:'var(--green)'};
const ROT_AREAS={geral:'📌 Geral',producao:'🏭 Produção',comercial:'🎯 Comercial',instalacao:'🔧 Instalação',administrativo:'🏢 Administrativo',financeiro:'💰 Financeiro'};

function renderRotinas(){
  const tarefas=CACHE.tarefas||[];
  const area=document.getElementById('rot-filtro-area')?.value||'';
  const respF=document.getElementById('rot-filtro-resp')?.value||'';
  // Populate responsavel filter
  const selResp=document.getElementById('rot-filtro-resp');
  if(selResp){
    const cur=selResp.value;
    selResp.innerHTML='<option value="">Todos os responsáveis</option>'+(CACHE.pessoas||[]).filter(p=>p.status==='ativo').map(p=>`<option value="${p.id}" ${p.id===cur?'selected':''}>${escapeHtml(p.nome)}</option>`).join('');
  }
  let filtradas=tarefas;
  if(area)filtradas=filtradas.filter(t=>t.area===area);
  if(respF)filtradas=filtradas.filter(t=>t.responsavelId===respF);
  const td=today();
  const total=filtradas.length,pendentes=filtradas.filter(t=>t.status==='pendente').length,andamento=filtradas.filter(t=>t.status==='em_andamento').length,atrasadas=filtradas.filter(t=>t.prazo&&t.prazo<td&&!['concluido','cancelado'].includes(t.status)).length,concluidas=filtradas.filter(t=>t.status==='concluido').length;
  const kpi=document.getElementById('rot-kpis');
  if(kpi)kpi.innerHTML=`<div class="card"><label>Total</label><div class="val">${total}</div></div><div class="card warn"><label>A fazer</label><div class="val">${pendentes}</div></div><div class="card accent"><label>Em andamento</label><div class="val">${andamento}</div></div><div class="card ${atrasadas?'red':'green'}"><label>Atrasadas</label><div class="val">${atrasadas}</div></div><div class="card green"><label>Concluídas</label><div class="val">${concluidas}</div></div>`;
  const kanban=document.getElementById('rot-kanban');
  if(!kanban)return;
  kanban.innerHTML=Object.keys(ROT_STATUS).map(status=>{
    const cards=filtradas.filter(t=>t.status===status);
    return`<div class="rot-col"><div class="rot-col-hdr"><span style="font-weight:750;font-size:11.5px;text-transform:uppercase;letter-spacing:.05em;color:${ROT_STATUS_COL[status]}">${ROT_STATUS[status]}</span><span style="background:var(--surface3);color:var(--muted);font-size:11px;padding:2px 8px;border-radius:99px;font-weight:700">${cards.length}</span></div><div style="padding:10px;min-height:80px">${cards.length?cards.map(t=>_rotinaCardHTML(t)).join(''):'<div style="color:var(--muted);font-size:12px;text-align:center;padding:20px 8px">Sem tarefas</div>'}</div></div>`;
  }).join('');
}

function _rotinaCardHTML(t){
  const td=today(),atrasada=t.prazo&&t.prazo<td&&!['concluido','cancelado'].includes(t.status);
  const resp=(CACHE.pessoas||[]).find(p=>p.id===t.responsavelId);
  const ped=(CACHE.pedidos||[]).find(p=>p.id===t.pedidoId);
  const cl=t.checklists||[],clF=cl.filter(c=>c.feito).length;
  const borda=atrasada?'var(--red)':t.prioridade==='alta'?'color-mix(in srgb,var(--red) 50%,var(--border))':'var(--border)';
  return`<div class="rot-card" onclick="openRotinaForm('${t.id}')" style="border-color:${borda}">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:6px;margin-bottom:7px">
      <span style="font-size:12.5px;font-weight:650;line-height:1.35;color:var(--text)">${escapeHtml(t.titulo)}</span>
      ${t.prioridade==='alta'?'<span style="color:var(--red);font-size:11px;flex-shrink:0">🔴</span>':''}
    </div>
    <div style="display:flex;flex-wrap:wrap;gap:5px;margin-bottom:7px">
      <span style="font-size:10px;background:var(--surface2);color:var(--muted);padding:2px 7px;border-radius:99px">${ROT_AREAS[t.area]||t.area||'Geral'}</span>
      ${resp?`<span style="font-size:10px;background:var(--surface2);color:var(--accent);padding:2px 7px;border-radius:99px">👤 ${escapeHtml(resp.nome.split(' ')[0])}</span>`:''}
      ${ped?`<span style="font-size:10px;background:var(--surface2);color:var(--muted);padding:2px 7px;border-radius:99px">#${escapeHtml(ped.num||'?')}</span>`:''}
    </div>
    <div style="display:flex;justify-content:space-between;align-items:center">
      ${t.prazo?`<span style="font-size:11px;color:${atrasada?'var(--red)':'var(--muted)'}">${atrasada?'⚠️ ':''} ${fmtD(t.prazo)}</span>`:'<span></span>'}
      ${cl.length?`<span style="font-size:11px;color:${clF===cl.length?'var(--green)':'var(--muted)'}">☑ ${clF}/${cl.length}</span>`:''}
    </div>
    <div style="display:flex;gap:4px;margin-top:7px;flex-wrap:wrap">
      ${['pendente','em_andamento','aguardando','concluido'].filter(s=>s!==t.status).map(s=>`<button class="btn btn-ghost btn-sm" style="font-size:10px;padding:2px 7px;min-height:24px" onclick="event.stopPropagation();moverRotina('${t.id}','${s}')">${ROT_STATUS[s]}</button>`).join('')}
    </div>
  </div>`;
}

function openRotinaForm(id){
  const t=id?(CACHE.tarefas||[]).find(x=>x.id===id):null;
  document.getElementById('rot-modal-title').textContent=t?'Editar Tarefa':'Nova Tarefa';
  document.getElementById('rot-id').value=t?.id||'';
  document.getElementById('rot-titulo').value=t?.titulo||'';
  document.getElementById('rot-desc').value=t?.descricao||'';
  document.getElementById('rot-area').value=t?.area||'geral';
  document.getElementById('rot-prioridade').value=t?.prioridade||'normal';
  document.getElementById('rot-prazo').value=t?.prazo||'';
  document.getElementById('rot-status').value=t?.status||'pendente';
  document.getElementById('rot-del-btn').style.display=t?'inline-flex':'none';
  const resp=document.getElementById('rot-responsavel');
  resp.innerHTML='<option value="">— Sem responsável</option>'+(CACHE.pessoas||[]).filter(p=>p.status==='ativo').map(p=>`<option value="${p.id}" ${t?.responsavelId===p.id?'selected':''}>${escapeHtml(p.nome)}</option>`).join('');
  const ped=document.getElementById('rot-pedido');
  ped.innerHTML='<option value="">— Sem pedido</option>'+(CACHE.pedidos||[]).filter(p=>!['pago','cancelado'].includes(p.status)).map(p=>`<option value="${p.id}" ${t?.pedidoId===p.id?'selected':''}>#${escapeHtml(p.num||'?')} · ${escapeHtml(p.cliente||'')}</option>`).join('');
  const cl=document.getElementById('rot-checklist');
  cl.innerHTML='';
  (t?.checklists||[]).forEach((item,i)=>cl.insertAdjacentHTML('beforeend',_clItemHTML(item,i)));
  const hw=document.getElementById('rot-historico-wrap');
  const hd=document.getElementById('rot-historico');
  if(t?.historico?.length&&hw&&hd){hw.style.display='';hd.innerHTML=t.historico.slice(-5).reverse().map(h=>`<div style="padding:3px 0;border-bottom:1px solid var(--border)">${h.ts?new Date(h.ts).toLocaleString('pt-BR',{day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'}):'—'} · <strong>${escapeHtml(h.user||'?')}</strong> · ${escapeHtml(h.acao||'')}</div>`).join('');}
  else if(hw)hw.style.display='none';
  openModal('modal-rotina');
}

function _clItemHTML(item,i){
  return`<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px">
    <input type="checkbox" ${item.feito?'checked':''} style="flex-shrink:0;width:16px;height:16px;cursor:pointer">
    <input class="si rot-cl-input" style="flex:1;height:34px;${item.feito?'text-decoration:line-through;color:var(--muted)':''}" value="${escapeHtml(item.texto||'')}">
    <button class="btn btn-ghost btn-sm" type="button" style="min-height:34px;padding:4px 8px" onclick="this.parentElement.remove()">✕</button>
  </div>`;
}

function addRotinaChecklistItem(){
  const cl=document.getElementById('rot-checklist');
  cl.insertAdjacentHTML('beforeend',_clItemHTML({texto:'',feito:false},cl.children.length));
  cl.lastElementChild.querySelector('.rot-cl-input')?.focus();
}

async function saveRotina(){
  const titulo=document.getElementById('rot-titulo').value.trim();
  if(!titulo){toast('Título obrigatório','warn');return;}
  const id=document.getElementById('rot-id').value;
  const agora=new Date().toISOString();
  const userNome=document.getElementById('tb-user')?.textContent||'Usuário';
  const clRows=Array.from(document.getElementById('rot-checklist').children);
  const checklists=clRows.map(row=>{
    const cb=row.querySelector('input[type=checkbox]');
    const inp=row.querySelector('.rot-cl-input');
    return{id:Date.now()+Math.random(),texto:inp?.value?.trim()||'',feito:!!cb?.checked};
  }).filter(c=>c.texto);
  const existing=id?(CACHE.tarefas||[]).find(t=>t.id===id):null;
  const historico=[...(existing?.historico||[]),{ts:agora,user:userNome,acao:id?'editado':'criado'}];
  const obj={
    ...(existing||{}),
    id:id||Date.now().toString(),
    titulo,
    descricao:document.getElementById('rot-desc').value.trim(),
    area:document.getElementById('rot-area').value||'geral',
    prioridade:document.getElementById('rot-prioridade').value||'normal',
    prazo:document.getElementById('rot-prazo').value||'',
    status:document.getElementById('rot-status').value||'pendente',
    responsavelId:document.getElementById('rot-responsavel').value||'',
    pedidoId:document.getElementById('rot-pedido').value||'',
    checklists,historico,
    criadoEm:existing?.criadoEm||agora,atualizadoEm:agora
  };
  const lista=[...(CACHE.tarefas||[])];
  const ix=lista.findIndex(t=>t.id===obj.id);
  if(ix>=0)lista[ix]=obj;else lista.unshift(obj);
  await DB.set('tarefas',lista);
  await auditar(id?'editar':'criar','tarefas',`${id?'Editou':'Criou'} tarefa ${titulo}`,existing||null,obj);
  closeModal('modal-rotina');renderRotinas();toast('Tarefa salva ✓');
}

async function deleteRotina(){
  const id=document.getElementById('rot-id').value;
  if(!id||!await uiConfirm({tone:'danger',eyebrow:'Rotina operacional',title:'Excluir esta tarefa?',impact:'A tarefa e seu acompanhamento serão removidos.',confirmLabel:'Excluir tarefa'}))return;
  const antes=(CACHE.tarefas||[]).find(t=>t.id===id);
  await DB.remove('tarefas',id);
  await auditar('excluir','tarefas',`Excluiu tarefa ${antes?.titulo||id}`,antes||null,null);
  closeModal('modal-rotina');renderRotinas();toast('Tarefa excluída');
}

async function moverRotina(id,status){
  const lista=[...(CACHE.tarefas||[])];
  const ix=lista.findIndex(t=>t.id===id);
  if(ix<0)return;
  const antes={...lista[ix]};
  const userNome=document.getElementById('tb-user')?.textContent||'Usuário';
  lista[ix]={...lista[ix],status,atualizadoEm:new Date().toISOString(),historico:[...(lista[ix].historico||[]),{ts:new Date().toISOString(),user:userNome,acao:`status → ${ROT_STATUS[status]||status}`}]};
  await DB.set('tarefas',lista);
  await auditar('status','tarefas',`Tarefa ${lista[ix].titulo}: ${ROT_STATUS[antes.status]||antes.status} → ${ROT_STATUS[status]||status}`,antes,lista[ix]);
  renderRotinas();
}

